/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseProjectDtoPage } from '../models/base-project-dto-page';
import { BaseProjectGroupDtoPage } from '../models/base-project-group-dto-page';
import { BaseProjectUserDtoPage } from '../models/base-project-user-dto-page';
import { cloneProject } from '../fn/projects/clone-project';
import { CloneProject$Params } from '../fn/projects/clone-project';
import { createProject } from '../fn/projects/create-project';
import { CreateProject$Params } from '../fn/projects/create-project';
import { deleteProject } from '../fn/projects/delete-project';
import { DeleteProject$Params } from '../fn/projects/delete-project';
import { getProject } from '../fn/projects/get-project';
import { GetProject$Params } from '../fn/projects/get-project';
import { getProjectsStats } from '../fn/projects/get-projects-stats';
import { GetProjectsStats$Params } from '../fn/projects/get-projects-stats';
import { getProjectStats } from '../fn/projects/get-project-stats';
import { GetProjectStats$Params } from '../fn/projects/get-project-stats';
import { getProjectWorkPackageCategoryGroups } from '../fn/projects/get-project-work-package-category-groups';
import { GetProjectWorkPackageCategoryGroups$Params } from '../fn/projects/get-project-work-package-category-groups';
import { GuidCounterDto } from '../models/guid-counter-dto';
import { listProjectGroups } from '../fn/projects/list-project-groups';
import { ListProjectGroups$Params } from '../fn/projects/list-project-groups';
import { listProjectMembers } from '../fn/projects/list-project-members';
import { ListProjectMembers$Params } from '../fn/projects/list-project-members';
import { listProjects } from '../fn/projects/list-projects';
import { ListProjects$Params } from '../fn/projects/list-projects';
import { ProjectDto } from '../models/project-dto';
import { ProjectStatusCounterDto } from '../models/project-status-counter-dto';
import { ProjectWorkPackageCategoryGroupsDto } from '../models/project-work-package-category-groups-dto';
import { updateProject } from '../fn/projects/update-project';
import { UpdateProject$Params } from '../fn/projects/update-project';

@Injectable({ providedIn: 'root' })
export class ProjectsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listProjects()` */
  static readonly ListProjectsPath = '/v0/projects';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProjects$Response(params?: ListProjects$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseProjectDtoPage>> {
    return listProjects(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProjects(params?: ListProjects$Params, context?: HttpContext): Observable<BaseProjectDtoPage> {
    return this.listProjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseProjectDtoPage>): BaseProjectDtoPage => r.body)
    );
  }

  /** Path part for operation `createProject()` */
  static readonly CreateProjectPath = '/v0/projects';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProject$Response(params: CreateProject$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectDto>> {
    return createProject(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProject(params: CreateProject$Params, context?: HttpContext): Observable<ProjectDto> {
    return this.createProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProjectDto>): ProjectDto => r.body)
    );
  }

  /** Path part for operation `getProject()` */
  static readonly GetProjectPath = '/v0/projects/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProject$Response(params: GetProject$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectDto>> {
    return getProject(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProject(params: GetProject$Params, context?: HttpContext): Observable<ProjectDto> {
    return this.getProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProjectDto>): ProjectDto => r.body)
    );
  }

  /** Path part for operation `updateProject()` */
  static readonly UpdateProjectPath = '/v0/projects/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProject$Response(params: UpdateProject$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateProject(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProject(params: UpdateProject$Params, context?: HttpContext): Observable<void> {
    return this.updateProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteProject()` */
  static readonly DeleteProjectPath = '/v0/projects/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProject$Response(params: DeleteProject$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteProject(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProject(params: DeleteProject$Params, context?: HttpContext): Observable<void> {
    return this.deleteProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getProjectsStats()` */
  static readonly GetProjectsStatsPath = '/v0/projects/stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProjectsStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectsStats$Response(params?: GetProjectsStats$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectStatusCounterDto>> {
    return getProjectsStats(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProjectsStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectsStats(params?: GetProjectsStats$Params, context?: HttpContext): Observable<ProjectStatusCounterDto> {
    return this.getProjectsStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProjectStatusCounterDto>): ProjectStatusCounterDto => r.body)
    );
  }

  /** Path part for operation `getProjectStats()` */
  static readonly GetProjectStatsPath = '/v0/projects/{id}/stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProjectStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectStats$Response(params: GetProjectStats$Params, context?: HttpContext): Observable<StrictHttpResponse<GuidCounterDto>> {
    return getProjectStats(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProjectStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectStats(params: GetProjectStats$Params, context?: HttpContext): Observable<GuidCounterDto> {
    return this.getProjectStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<GuidCounterDto>): GuidCounterDto => r.body)
    );
  }

  /** Path part for operation `listProjectMembers()` */
  static readonly ListProjectMembersPath = '/v0/projects/{id}/members';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProjectMembers()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProjectMembers$Response(params: ListProjectMembers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseProjectUserDtoPage>> {
    return listProjectMembers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProjectMembers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProjectMembers(params: ListProjectMembers$Params, context?: HttpContext): Observable<BaseProjectUserDtoPage> {
    return this.listProjectMembers$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseProjectUserDtoPage>): BaseProjectUserDtoPage => r.body)
    );
  }

  /** Path part for operation `listProjectGroups()` */
  static readonly ListProjectGroupsPath = '/v0/projects/{id}/groups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProjectGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProjectGroups$Response(params: ListProjectGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseProjectGroupDtoPage>> {
    return listProjectGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProjectGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProjectGroups(params: ListProjectGroups$Params, context?: HttpContext): Observable<BaseProjectGroupDtoPage> {
    return this.listProjectGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseProjectGroupDtoPage>): BaseProjectGroupDtoPage => r.body)
    );
  }

  /** Path part for operation `getProjectWorkPackageCategoryGroups()` */
  static readonly GetProjectWorkPackageCategoryGroupsPath = '/v0/projects/{id}/categoryGroups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProjectWorkPackageCategoryGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectWorkPackageCategoryGroups$Response(params: GetProjectWorkPackageCategoryGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectWorkPackageCategoryGroupsDto>> {
    return getProjectWorkPackageCategoryGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProjectWorkPackageCategoryGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectWorkPackageCategoryGroups(params: GetProjectWorkPackageCategoryGroups$Params, context?: HttpContext): Observable<ProjectWorkPackageCategoryGroupsDto> {
    return this.getProjectWorkPackageCategoryGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProjectWorkPackageCategoryGroupsDto>): ProjectWorkPackageCategoryGroupsDto => r.body)
    );
  }

  /** Path part for operation `cloneProject()` */
  static readonly CloneProjectPath = '/v0/projects/clone';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cloneProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cloneProject$Response(params: CloneProject$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectDto>> {
    return cloneProject(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cloneProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cloneProject(params: CloneProject$Params, context?: HttpContext): Observable<ProjectDto> {
    return this.cloneProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProjectDto>): ProjectDto => r.body)
    );
  }

}
